
<div class="notification" [ngClass]="{ '-displayNone': hideNotification }">
  <wp-inline-banner
    [attr.actionButton]="actionButton"
    [attr.action-button-text]="actionButtonText"
    [closeButton]="closeButton"
    [attr.tone]="tone"
    [attr.dismiss]="dismiss"
    (closedBanner)="onClosedBanner($event)">
    <span slot="title">{{ title }}</span>
    <span slot="message">
      <p><ng-content></ng-content></p>
    </span>
  </wp-inline-banner>
</div>